import React from 'react';
import ApexCharts from 'react-apexcharts';
import noData from "../../../assets/images/noData.png"

// const groupDataByLocation = (data) => {
//   const groupedData = data?.reduce((acc, curr) => {
//     const { state, total_trades, total_price } = curr;
//     if (acc[state]) {
//       acc[state].total_trades += total_trades;
//       acc[state].total_price += total_price;
//     } else {
//       acc[state] = {
//         total_trades: total_trades,
//         total_price: total_price,
//       };
//     }
//     return acc;
//   }, {});

//   return Object.entries(groupedData).map(([state, values]) => ({
//     state,
//     total_trades: values.total_trades,
//     total_price: values.total_price,
//   }));
// };
const groupDataByLocation = (data = []) => {
  const groupedData = data.reduce((acc, curr) => {
    const { state, total_trades = 0, total_price = 0 } = curr;
    if (!state) return acc; 
    if (acc[state]) {
      acc[state].total_trades += total_trades;
      acc[state].total_price += total_price;
    } else {
      acc[state] = {
        total_trades,
        total_price,
      };
    }
    return acc;
  }, {});

  return Object.entries(groupedData).map(([state, values]) => ({
    state,
    total_trades: values.total_trades,
    total_price: values.total_price,
  }));
};


const TradesChart = ({ data }) => {
  // Group data by location (state) and sum up total_trades and total_price
  const groupedData = groupDataByLocation(data);
  if (groupedData.length === 0) {
    return  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={noData} height="255px"/></div>
  }
  // Prepare data for the chart
  const categories = groupedData.map(item => item.state); // X-axis (locations)
  const totalTrades = groupedData.map(item => item.total_trades); // Y-axis (total trades)

  const chartOptions = {

    chart: {
      type: 'bar',
      height: 50,
    },
    xaxis: {
      categories: categories, // X-axis (States)
      title: {
        text: 'State',
        style: {
            fontSize: '14px',    // Font size
            fontFamily: 'Arial, sans-serif' ,
            fontWeight:"600",color:"#000000de"
          },
      },
    },
    yaxis: {
      title: {
        text: 'Total Trades',
        style: {
            fontSize: '14px',    // Font size
          
            fontFamily: 'Arial, sans-serif',
            fontWeight:"600",color:"#000000de"

          },
      },
    },
   
    colors: ['#f4a99b', '#a5faa5'], // Alternating colors
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '20%', // Reduces the width of each bar
        distributed: true, // Alternate bar colors
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels inside bars
    },
    tooltip: {
      y: {
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          const totalPrice = groupedData[dataPointIndex].total_price;
          return `Total Trades: ${value}<br/>Total Price: ₹${totalPrice.toLocaleString()}`; // Show total trades and total price in the tooltip
        },
      },
    },
    legend:{
     show:false
    }
  };

  const chartSeries = [
    {
      name: '',
      data: totalTrades, // Y-axis (Total Trades)
    },
  ];

  return (
    <div>
      <ApexCharts
        options={chartOptions}
        series={chartSeries}
        type="bar" // Bar chart to display total trades
        height={240}
      />
    </div>
  );
};

export default TradesChart;
